<div class="payment-selection-container" id="payment-page">
  <!-- Loading State -->
  <div *ngIf="state.isLoading || state.isRedirecting" class="loading-overlay" id="payment-loader">
    <div class="spinner" id="payment-spinner"></div>
  </div>

  <div *ngIf="!state.isLoading">
    <!-- Main Content -->
    <div *ngIf="!state.showErrorCard">
      <div class="row text-left justify-content-md-center">
        <!-- Header Section -->
        <div class="col-md-12">
          <div class="col-md-12 header payment-header" id="payment-header"
               [ngStyle]="{'background-color': pageStyle.HeaderColor}">
            <img class="logo-payment" id="payment-logo" [src]="logoImageUrl" alt="Company Logo"/>
          </div>
        </div>
      </div>

      <!-- Payment Section -->
      <div class="background-image payment-background" id="payment-background"
           [ngStyle]="{'background-image':'url(' + backgroundImageUrl + ')'}">
        <div class="row text-left justify-content-md-center">
          <div class="col-md-5">
            <div class="card payment-card" id="payment-card">
              <!-- Card Header -->
              <div class="card-header payment-card-header" id="payment-card-header">
                <h4 class="card-title payment-title" id="payment-selection-header"
                    [ngStyle]="{'color': pageStyle.HeadingTextColor}">
                  {{ 'paymentSelection.paymentTo' | translate }}: {{ paymentOptionResult?.CompanyName }}
                </h4>
              </div>

              <!-- Card Body -->
              <div class="card-body payment-card-body" id="payment-card-body">
                <div class="px-3 mt-1">
                  <!-- Title -->
                  <div class="mb-3">
                    <h5 class="text-center payment-subtitle" id="payment-subtitle"
                        [ngStyle]="{'color': pageStyle.HeadingTextColor}">
                      {{ paymentOptionResult?.Title }}
                    </h5>
                  </div>

                  <!-- Description -->
                  <div class="mb-4">
                    <p class="text-center payment-description" id="payment-description"
                       [ngStyle]="{'color': pageStyle.BodyTextColor}">
                      {{ paymentOptionResult?.Description }}
                    </p>
                  </div>

                  <!-- Amount Selection -->
                  <div class="form-group payment-amount-section" id="payment-amount-section">
                    <label class="payment-amount-label" [ngStyle]="{'color': pageStyle.BodyTextColor}">
                      {{ 'paymentSelection.selectAmount' | translate }}
                    </label>

                    <!-- Predefined Amounts Radio Buttons -->
                    <div class="amount-options payment-options" id="payment-options">
                      <div class="form-check mb-2 payment-amount-option"
                           *ngFor="let amount of paymentOptionResult?.PredefinedAmountsArray">
                        <input
                          class="form-check-input"
                          type="radio"
                          [id]="'amount-' + amount"
                          name="amountSelection"
                          [value]="amount"
                          [(ngModel)]="selectedAmountOption"
                          (change)="onAmountOptionChange(amount)"
                        >
                        <label class="form-check-label payment-amount-label" [for]="'amount-' + amount"
                               [ngStyle]="{'color': pageStyle.BodyTextColor}">
                          €{{ formatAmount(amount) }}
                        </label>
                      </div>

                      <!-- Custom Amount Radio Button -->
                      <div class="form-check mb-2 payment-custom-option" id="payment-custom-section"
                           *ngIf="allowCustomAmount">
                        <input
                          class="form-check-input"
                          type="radio"
                          id="amount-custom"
                          name="amountSelection"
                          value="custom"
                          [(ngModel)]="selectedAmountOption"
                          (change)="onAmountOptionChange('custom')"
                        >
                        <label class="form-check-label payment-custom-label" for="amount-custom"
                               [ngStyle]="{'color': pageStyle.BodyTextColor}">
                          {{ 'paymentSelection.customAmountLabel' | translate }}
                        </label>

                        <!-- Custom Amount Input -->
                        <div class="input-group mt-2 payment-custom-input" id="payment-custom-input"
                             *ngIf="isCustomSelected">
                          <div class="input-group-prepend">
                            <span class="input-group-text payment-currency">€</span>
                          </div>
                          <input
                            type="text"
                            class="form-control"
                            [placeholder]="'paymentSelection.amountPlaceholder' | translate"
                            [(ngModel)]="customAmountInput"
                            (input)="onCustomAmountInput($event)"
                            name="customAmount"
                          />
                        </div>
                        <small class="form-text text-muted payment-limits" id="payment-limits" *ngIf="isCustomSelected"
                               [ngStyle]="{'color': pageStyle.BodyTextColor}">
                          {{
                            'paymentSelection.amountLimits' | translate:{
                              min: MIN_AMOUNT,
                              max: formatAmount(MAX_AMOUNT)
                            }
                          }}
                        </small>
                      </div>
                    </div>
                  </div>

                  <!-- Payment Button -->
                  <button
                    class="btn btn-block payment-button"
                    id="payment-submit-button"
                    [ngClass]="{'btn-primary': !pageStyle?.ButtonColor}"
                    [ngStyle]="isValidPaymentSelection() && pageStyle?.ButtonColor ? {
                      'background-color': pageStyle.ButtonColor,
                      'border-color': pageStyle.ButtonColor
                    } : {}"
                    [disabled]="!isValidPaymentSelection() || this.state.isRedirecting"
                    (click)="onPaymentSubmit()">
                    {{ 'paymentSelection.payButton' | translate }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Error State -->
    <div *ngIf="state.showErrorCard" class="error-container payment-error" id="payment-error">
      <div class="alert alert-danger payment-error-alert">
        <h4 [ngStyle]="{'color': pageStyle.HeadingTextColor}">{{ 'paymentSelection.errorTitle' | translate }}</h4>
        <p [ngStyle]="{'color': pageStyle.BodyTextColor}">{{ 'paymentSelection.errorMessage' | translate }}</p>
        <button
          class="btn btn-outline-danger payment-error-button"
          id="payment-retry-button"
          (click)="fetchPaymentOptions()"
          [disabled]="state.isLoading">
          {{ 'paymentSelection.tryAgainButton' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
